import StoreContext from './store';

export default StoreContext;
